<template>
    <svg viewBox="0 0 18 31" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.0704 30.4374C16.6799 30.8279 16.0467 30.8279 15.6562 30.4374L0.58432 15.3656L15.6562 0.293718C16.0467 -0.0968055 16.6799 -0.0968055 17.0704 0.293718C17.4609 0.684242 17.4609 1.31741 17.0704 1.70793L3.41275 15.3656L17.0704 29.0232C17.4609 29.4137 17.4609 30.0469 17.0704 30.4374Z"
            fill="currentColor"
        />
    </svg>
</template>
